import { from} from "rxjs";
import request from "./request"
const createLoader = options => from(request(options));
export default createLoader;